import { render, staticRenderFns } from "./BerkleyPremiumCommission.vue?vue&type=template&id=aeaf85fc"
import script from "./BerkleyPremiumCommission.vue?vue&type=script&lang=js"
export * from "./BerkleyPremiumCommission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports